import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import {Program} from '../interface/program';
import {Student} from '../interface/student';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ProgramService {
  httpOptions:any;
  headers:any;

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http:HttpClient) 
    {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
        })
      };
    }
 
// Create Program | Update Program
  postProgram(url,param){
  return this.http.post<Program>(url,param,this.httpOptions)
  .pipe(
    tap(() =>  {
      this._refreshNeeded$.next();
    })
  );
  }

  postStudent(url,param){
  return this.http.post<Student>(url,param,this.httpOptions)
  }

  getAllProgram(url){
    return this.http.get(url,this.httpOptions)
  }

  getProgramByID(url,param){
    return this.http.post<Program>(url,param,this.httpOptions)
  }

  updateProgram(url,param){
    return this.http.put<Student>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
  
  deleteProgramByID(url,param){
    return this.http.put<Program>(url,param,this.httpOptions)
    .pipe(
      tap(() =>  {
        this._refreshNeeded$.next();
      })
    );
  }
}
